import { DynamicStructuredTool } from '@langchain/core/tools';

/**
 * Pure synchronous helper — copies, sorts alphabetically by tool name,
 * then freezes the outer array. Individual tool objects are NOT frozen.
 */
export const freezeAndSortTools = (tools: DynamicStructuredTool[]): readonly DynamicStructuredTool[] => {
  return Object.freeze(
    [...tools].sort((a, b) => a.name.localeCompare(b.name))
  );
};
